/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { CodeMultiInput } from './PlansModalControll/CodeMultiInput';
import { v4 } from 'uuid';
import { Plan } from './PlansModalControll/interfaces/PlanIntrfaces';

export function MultiInputDdf(props) {
  const {
    input,
    meta: { error, modified }
  } = useFieldApi(props);

  const isError = modified && error && typeof error === 'string';
  let plans: Plan[] = [];
  if (Array.isArray(input?.value)) {
    plans = input.value.map((plan) => ({ ...plan, id: v4() }));
  }

  return <CodeMultiInput {...props} {...input} value={plans} isError={isError} error={error} />;
}
